import { createFileRoute } from '@tanstack/react-router';
import { CourseCatalogPage } from '@/pages/courses/CourseCatalogPage';
import { z } from 'zod';

const coursesSearchSchema = z.object({
	page: z.coerce.number().default(1),
	search: z.string().optional(),
	categoryId: z.string().optional(),
	type: z.enum(['COURSE', 'WEBINAR']).optional(),
	startDate: z.string().optional(),
	endDate: z.string().optional(),
	availableOnly: z.coerce.boolean().optional(),
	sortBy: z.enum(['date', 'title', 'category']).optional(),
	tab: z.enum(['PUBLISHED', 'DRAFT', 'CANCELLED', 'COMPLETED']).optional(),
});

export const Route = createFileRoute('/_authenticated/_app/courses/')({
	component: CourseCatalogPage,
	validateSearch: coursesSearchSchema,
});
